import useSWR, { type SWRConfiguration } from 'swr';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import type { SystemHealthSummary } from './types';

const POLL_INTERVAL_MS = 30_000;

export function useSystemHealthSummary(options?: SWRConfiguration<SystemHealthSummary>) {
  const { can, permissionsLoaded } = useAuth();
  const enabled = permissionsLoaded && can('system_health', 'view');

  return useSWR<SystemHealthSummary>(
    enabled ? '/system-health/summary' : null,
    async (url: string) => {
      const res = await api.get(url, { timeout: 15_000 });
      return res.data;
    },
    {
      refreshInterval: POLL_INTERVAL_MS,
      revalidateOnFocus: true,
      dedupingInterval: 10_000,
      ...options,
    },
  );
}
